import React from "react";
import { Box, Chip, Grid, Paper, Typography } from "@mui/material";
import { useSelectedBusiness } from "../../../../../platform/redux/store";
import { BookingType } from "../../../../../platform/types";

interface SpecificBookingTypeInfo {
  bookingTypeId: number;
  title: string;
  time: number;
  color: string;
  price: number;
}

const BookingTypeStaffForm = (props: any) => {
  const selectedStaff = props.staff;
  const selectedBusiness = useSelectedBusiness();
  const bookingTypes = selectedBusiness?.businessBookingTypes;

  // Get only the booking types associated with the selected staff
  const specificBookingTypesInfos = getSpecificBookingTypesInfo(
    selectedStaff.id,
    bookingTypes ?? []
  );

  function getSpecificBookingTypesInfo(
    staffId: number,
    bkingTypes: BookingType[]
  ): SpecificBookingTypeInfo[] {
    const results: SpecificBookingTypeInfo[] = [];

    bkingTypes.forEach((bookingType) => {
      // Find if this booking type is assigned to the selected staff
      const assignedStaff = bookingType.assignedStaffs.find(
        (staff: any) => Number(staff.staffId) === Number(staffId)
      );
      if (assignedStaff) {
        results.push({
          bookingTypeId: bookingType.id,
          title: bookingType.title,
          time: bookingType.length,
          color: bookingType.color,
          price: bookingType.price,
        });
      }
    });

    return results.sort((a, b) => String(a.title).localeCompare(String(b.title)));
  }

  if (specificBookingTypesInfos.length === 0) {
    return (
      <Paper
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 2,
          bgcolor: "background.paper",
          borderStyle: "dashed",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No booking types assigned to this staff yet.
        </Typography>
      </Paper>
    );
  }

  return (
    <Grid container spacing={1}>
      {specificBookingTypesInfos.map(
        (info: SpecificBookingTypeInfo) => (
          <Grid item xs={12} key={info.bookingTypeId}>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 1,
                borderRadius: 2,
                bgcolor: "background.paper",
              }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  flexShrink: 0,
                  bgcolor: info.color || "#7b8ea3",
                }}
              />
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 1.2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {info.title || "Untitled booking type"}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", justifyContent: "flex-end" }}>
                <Chip
                  size="small"
                  variant="outlined"
                  label={`${info.time || 0} mins`}
                  sx={{ fontWeight: 700 }}
                />
                <Chip
                  size="small"
                  variant="outlined"
                  label={info.price !== null ? `$${info.price}` : "Free"}
                  sx={{ fontWeight: 700 }}
                />
              </Box>
            </Paper>
          </Grid>
        )
      )}
    </Grid>
  );
};

export default BookingTypeStaffForm;
